module.exports = __webpack_public_path__ + "img/RX-Arcos-4.100f18ed.png";